import React, { Component } from "react";
import { Link } from 'react-router-dom';

class Ethics extends Component {
  render() {
    return (
    <div>
      <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">รู้จักสหกรณ์</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="ethics" className="a-breadcrumbs">จรรยาบรรณ</a>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50">
                <h2 className="title-section mt-0 mb-0"><span>จรรยาบรรณ</span></h2><br/>
                <div className="divider gray left mt-20 mb-25" />
                <a href="ethicsmember" target="_blank" className="cws-button" style={{fontSize: 19}}>จรรยาบรรณของสมาชิกสหกรณ์</a>
                <br />
                <br />
                <a href="ethicsboard" target="_blank" className="cws-button" style={{fontSize: 19}}>จรรยาบรรณของคณะกรรมการสหกรณ์</a>
                <br />
                <br />
                <a href="ethicsofficer" target="_blank" className="cws-button" style={{fontSize: 19}}>จรรยาบรรณของเจ้าหน้าที่สหกรณ์</a>
                <br />
                <br />
                <a href="Form/Annoucement/1-2565%20%E0%B8%9B%E0%B8%A3%E0%B8%B0%E0%B8%A1%E0%B8%A7%E0%B8%A5%E0%B8%88%E0%B8%A3%E0%B8%B4%E0%B8%A2%E0%B8%98%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B8%81%E0%B8%A3%E0%B8%A3%E0%B8%A1%E0%B8%81%E0%B8%B2%E0%B8%A3%20%E0%B8%9C%E0%B8%B9%E0%B9%89%E0%B8%88%E0%B8%B1%E0%B8%94%E0%B8%81%E0%B8%B2%E0%B8%A3%20%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%9B%E0%B8%A3%E0%B8%B6%E0%B8%81%E0%B8%A9%E0%B8%B2%20%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B9%80%E0%B8%88%E0%B9%89%E0%B8%B2%E0%B8%AB%E0%B8%99%E0%B9%89%E0%B8%B2%E0%B8%97%E0%B8%B5%E0%B9%88.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>จริยธรรม</a>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>
            </div>
          </div>
        </section>

      </div>
      );
  }
}

export default Ethics;
